var exports = {
  "p": "SidebarResizeHandle.module__handle___VHdfMG",
  "q": "SidebarResizeHandle.module__indicator___VHdfMG",
};

module.exports = exports;
